const getters = {
  token: state => state.user.token,
  userInfo: state => state.user.userInfo
}
export default getters



//////////////////
// WEBPACK FOOTER
// ./app/store/getter.js
// module id = null
// module chunks = 